import api from 'api';
import { NextPageContext } from 'next';

interface Params {
  calendarEventId: number | string;
  req: NextPageContext['req'];
}

const getCalendarEventPageData = async ({ calendarEventId, req }: Params) => {
  try {
    const headers = req?.headers?.cookie ? { Cookie: req.headers.cookie } : {};
    const calendarEvents = await api.get(
      `/admin/calendar-events?id=${calendarEventId}`,
      { ...(headers.Cookie ? { headers } : {}) }
    );
    if (!calendarEvents.data.events?.length) {
      calendarEvents.status = 404;
      throw calendarEvents;
    }
    return calendarEvents.data.events[0];
  } catch (error) {
    return null;
  }
};

export default getCalendarEventPageData;
